import BlobFilterPanel from 'src/Admin/components/User/BlobEmployerLocation';
import '../../../User/association.scss';
const BlobEmployerLocationSelection = ({
  setSendToBlobDataHandler,
  formFields,
  isBlobEmpLocFlow,
  userTypeSelectedValue,
}) => {
  const onSelectedBlobCount = (length) => {
    console.log('length', length);
  };

  const handleValChange = (event) => {
    setSendToBlobDataHandler(event?.target?.value);
  };
  const nextStep = () => {
    console.log('nextStep values');
  };

  return (
    <div className="association-container">
      <h2 className="blob-permission-plan-section-heading mt-4">
        {`${
          (!isBlobEmpLocFlow && userTypeSelectedValue === 'Broker') ||
          userTypeSelectedValue === 'Client'
            ? ''
            : 'Block of Business+'
        }Employer+Location`}
      </h2>
      <BlobFilterPanel
        onSelectedBlobCount={onSelectedBlobCount}
        handleValChange={handleValChange}
        createUserFormData={formFields}
        isContinueClicked={false}
        nextStep={nextStep}
        showEmployerOnly={
          (!isBlobEmpLocFlow && userTypeSelectedValue === 'Broker') ||
          userTypeSelectedValue === 'Client'
        }
        editAffiliatedRecords={true}
      />
    </div>
  );
};

export default BlobEmployerLocationSelection;
